document.addEventListener('turbolinks:load', () => {
    const diskUsageContainer = document.getElementById('diskUsageContainer')

    if (diskUsageContainer !== null) {
        $.rails.ajax({
            url: "/media_entries/get_used_storage/",
            type: "get",
        })
    }
})